import {
  PrimaryTextColor,
  boldFont,
  centerItemFlex,
  getRelativeFontSize,
  mediumFont,
  normalFont,
  primaryBlueColor,
  regularFont,
} from "../../../../utils/styles";
import BackgroundImg from "../../../../assets/images/bg-pattern-1.svg";

const MobileVerificationStyle = {
  mainContentWrapper: {
    backgroundImage: `url(${BackgroundImg})`,
    backgroundRepeat: " no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    height: "100vh",
    width: "100%",
  },
  contentWrapper: {
    width: "100%",
    height: "100vh",
    ...centerItemFlex,
    flexDirection: "column",
    gap: 2,
  },
  cardContentWrapper: {
    padding: "45px 23px 0px 23px",
  },
  cardHeader: {},
  cardTitle: {
    fontSize: getRelativeFontSize(10),
    ...boldFont,
    color: PrimaryTextColor,
  },
  cardSubText: {
    fontSize: getRelativeFontSize(),
    ...regularFont,
    color: PrimaryTextColor,
  },
  cardContent: {
    marginTop: "52px",
  },
  cardFooter: {
    display: "flex",
    gap: "10px",
    flexDirection: "column",
    marginTop: 3,
  },
  signUpStyle: {
    fontSize: getRelativeFontSize(),
    ...regularFont,
  },
  disclamer: {
    color: "#9E9FAB",
    ...regularFont,
    fontSize: "14px",
  },
  backToLogin: {
    color: primaryBlueColor,
    cursor: "pointer",
    ...mediumFont,
    textAlign: "center",
    fontSize: "16px",
    marginTop: "10px",
  },
};

export default MobileVerificationStyle;
